import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import {Alert, Icon, Layout, Input } from 'antd';
import { Helmet } from 'react-helmet';

import AdminHeader from '../../components/AdminHeader/AdminHeader';
import Footer from '../../components/Footer/Footer';
import FollowUp90DayForm from '../../components/FollowUp90DayForm/FollowUp90DayForm';

import classes from './FollowUp90Day.css';

import isAuthenticated from '../../utils/isAuthenticated';
import { getFollowUpRequest } from '../../api/requests';
import { logout } from "../../reducers/user/actions";
import {getFollowUp90dReadPermission } from "../../reducers/user/selectors";

const { Content } = Layout;
const { Search } = Input;


class FollowUp90Day extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      subject: null,
      subjectID: null,
      errorMessage: null,
      isLoading: false,
    };
  }

  componentDidMount() {
    if (get(this.props, 'match.params.subjectID')) {
      this.onFollowUpSearch(get(this.props, 'match.params.subjectID'));
    }
  }

  onFollowUpSearch = async (value) => {
    if (value.trim()) {
      this.setState({ subjectID: value, errorMessage: null, subject: null, isLoading: true });
      try {
        const {data} = await getFollowUpRequest(value);
        this.setState({
          subject: {...data},
        });
      } catch (e) {
        if (get(e, 'response.status') === 401) {
          this.props.logout();
          return;
        }
        this.setState({subject: null, errorMessage: get(e, 'response.data.error', 'Error')});
      }

      this.setState({isLoading: false});
    }
  };

  render() {
    const { subject, subjectID, errorMessage, isLoading } = this.state;
    const { followUp90dReadPermission } = this.props;

    return (
      <div style={{ backgroundColor: '#FAFAFA' }}>
        <Helmet>
          <title>Trial Management Portal: 90-day Follow Up</title>
        </Helmet>
        <Layout className={classes.parentContainer}>
          <AdminHeader />
          <Content className={classes.content}>
            <h3 className='headline-default'>90-day Follow Up</h3>

            {!followUp90dReadPermission && (<Alert type='error' message='Permission denied! You cannot perform this action.' />)}

            {followUp90dReadPermission && (<div>
              <div className={classes.searchWrapper}>
                <label>
                  <b className={classes.searchWrapperLabel}>SEARCH</b>
                  <Search
                    placeholder="By subject ID"
                    enterButton="Search"
                    size="large"
                    onSearch={this.onFollowUpSearch}
                    style={{ maxWidth: '500px'}}
                  />
                </label>
              </div>

              {errorMessage && (<Alert type='error' message={errorMessage} />)}

              {subject && <FollowUp90DayForm {...subject} subjectID={subjectID} onSubmit={this.onFollowUpSearch} />}

              {isLoading && <Icon type="loading" />}
            </div>)}

          </Content>
          <Footer noAdminLink />
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  followUp90dReadPermission: getFollowUp90dReadPermission(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(connect(mapStateToProps, mapDispatchToProps)(FollowUp90Day));



// WEBPACK FOOTER //
// ./src/containers/FollowUp90Day/FollowUp90Day.js